import React from 'react';
import { FlatIcon } from "./flaticon/Icon.js";
import { FontAwesomeIcon } from "./fontawesome/Icon.js";
import { MaterialIcon } from "./materialui/Icon.js";
/**
 * Enum for icon types
 */

export let iconType;

(function (iconType) {
  iconType[iconType["materialui"] = 0] = "materialui";
  iconType[iconType["fontawesome"] = 1] = "fontawesome";
  iconType[iconType["flaticon"] = 2] = "flaticon";
})(iconType || (iconType = {}));

/**
 * Main Icon component
 */
export const Icon = props => {
  const {
    type,
    color,
    classes,
    iconName,
    style,
    onClick,
    className,
    fontSize
  } = props;

  switch (type) {
    case iconType.materialui:
      return /*#__PURE__*/React.createElement(MaterialIcon, {
        color: color,
        fontSize: fontSize,
        classes: classes,
        iconName: iconName,
        style: style,
        onClick: onClick,
        className: className
      }, props.children);

    case iconType.flaticon:
      return /*#__PURE__*/React.createElement(FlatIcon, {
        color: color,
        fontSize: fontSize,
        classes: classes,
        iconName: iconName,
        style: style,
        onClick: onClick
      }, props.children);

    case iconType.fontawesome:
      return /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        color: color,
        fontSize: fontSize,
        classes: classes,
        iconName: iconName,
        style: style,
        onClick: onClick
      }, props.children);

    default:
      return /*#__PURE__*/React.createElement(MaterialIcon, {
        iconName: iconName,
        color: color || 'primary',
        fontSize: fontSize || 'default',
        classes: classes,
        className: className,
        onClick: onClick,
        style: style
      });
  }
};
//# sourceMappingURL=Icon.js.map